import { Field, FieldProps } from 'formik';
import React, { ReactNode } from 'react';
import { FormattedMessage, InjectedIntl, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import ErrorMessage from '../components/errorMessage/ErrorMessage';
import { InfoTooltip } from '../components/InfoTooltip';
import Switch from '../components/Switch';
import ValidationErrors from './validationErrors';

interface ISwitchFieldProps {
    id: string;
    labelMessage: FormattedMessage.MessageDescriptor | string;
    intl: InjectedIntl;
    value?: boolean;
    required?: boolean;
    tooltipText?: FormattedMessage.MessageDescriptor | string;
    disabled?: boolean;
    qaId?: string;
}

interface ISwitchFieldState {
    on: boolean;
}

const SwitchFieldWrapper = styled.div`
    padding-right: 37px;
    position: relative;
`;

class SwitchField extends React.Component<ISwitchFieldProps, ISwitchFieldState> {
    private readonly ID: string;

    constructor(props: ISwitchFieldProps) {
        super(props);

        const { id, value } = this.props;

        this.ID = id ? id : 'switch';

        this.state = {
            on: Boolean(value),
        };

        this.validate = this.validate.bind(this);
        this.renderSwitchField = this.renderSwitchField.bind(this);
    }

    public render() {
        return <Field name={this.ID} validate={this.validate} render={this.renderSwitchField} />;
    }

    private validate(value: boolean): string {
        const { intl, required } = this.props;

        if (required && !value) {
            return ValidationErrors.fieldRequiredMessage(intl, '');
        }

        return '';
    }

    private renderSwitchField({
        field,
        form: { touched, errors, setFieldValue },
    }: FieldProps): ReactNode {
        const { value, labelMessage, disabled, tooltipText, qaId } = this.props;
        const label =
            labelMessage && typeof labelMessage !== 'string' && labelMessage.id
                ? TranslationHelpers.getFormattedMessage(labelMessage.id)
                : labelMessage;
        const isTouched = touched && touched[this.ID];
        const errorMessage = isTouched && errors && errors[this.ID] ? errors[this.ID] : undefined;
        const onSwitch = ((on: boolean) => {
            if (!disabled) {
                setFieldValue(this.ID, on);
                this.setState({ on });
            }
        }).bind(this);

        return (
            <SwitchFieldWrapper data-qa-id={qaId}>
                <Switch value={Boolean(value)} onSwitch={onSwitch} disabled={disabled}>
                    {label}
                </Switch>
                {tooltipText ? (
                    <InfoTooltip
                        id="isShippingTooltip"
                        tooltipText={tooltipText}
                        touchSize={[40, 40]}
                        uniqueId={'isShippingTooltip'}
                    />
                ) : (
                    ''
                )}
                {errorMessage && <ErrorMessage message={errorMessage} />}
            </SwitchFieldWrapper>
        );
    }
}

export default injectIntl(SwitchField);
